import img1 from "../../assets/Images/Procurement/Procurement Purchases Payment.png"
import img2 from "../../assets/Images/Procurement/Procurement Purchases Payment Create Purchases.png"

export default function PurchasePayments() {
    return (
        <section id="purchase-payments" className="space-y-16">

            {/* SECTION TITLE */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-2">
                    3. Purchase Payments
                </h1>
                <p className="text-md text-slate-600 max-w-3xl">
                    Purchase Payments are used to record amounts paid to suppliers against
                    their purchases and to keep supplier balances accurate at all times.
                </p>


                {/* OVERVIEW */}
                <section className="bg-white border-l border-[#C9A24E] p-4 mt-2">
                    <h2 className="text-lg font-semibold mb-3">
                        Overview
                    </h2>
                    <p className="text-slate-600 text-sm">
                        The Purchase Payment module maintains a complete payment history for
                        supplier purchases. Each payment updates the purchase balance, supplier
                        balance, and payment status automatically across the system.
                    </p>
                </section>
            </section>

            {/* PAYMENT VOUCHER LIST */}
            <section className="">
                <div>
                    <h3 className="font-semibold mb-2">
                        Purchase Payment Voucher List
                    </h3>

                    <p className="text-slate-600 mb-4">
                        When the Purchase Payments module is opened, a list of all payment
                        vouchers is displayed.
                    </p>

                    <ul className="list-disc pl-5 text-slate-600 space-y-1">
                        <li>Voucher number</li>
                        <li>Linked purchase ID</li>
                        <li>Supplier name</li>
                        <li>Payment date</li>
                        <li>Paid amount</li>
                        <li>Payment method</li>
                        <li>Actions (Edit / Delete)</li>
                    </ul>
                </div>

                <div className="rounded-lg p-4 mt-4">
                    <img src={img1} alt="" />
                </div>
            </section>

            {/* ADD PAYMENT */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Creating a Purchase Payment Voucher
                </h3>

                <p className="text-slate-600 mb-4">
                    Clicking the <strong>Add New</strong> button opens the Purchase Payment
                    Voucher form where supplier payments are recorded.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Voucher number is auto-generated</li>
                    <li>Select purchase against which payment is made</li>
                    <li>Supplier name auto-fills from selected purchase</li>
                    <li>Received amount is entered manually</li>
                    <li>Due amount is calculated automatically</li>
                    <li>Payment date and method are selected</li>
                </ul>

                <div className=" rounded-lg p-4 mt-4">
                    <img src={img2} alt="" />
                </div>
            </section>

            {/* AUTO CALCULATIONS */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Automatic Calculations
                </h3>

                <p className="text-slate-600 mb-4">
                    EventFlow automatically calculates balances to eliminate manual errors.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Due amount is calculated from purchase balance</li>
                    <li>Partial payments are supported</li>
                    <li>Multiple payments can be made against a single purchase</li>
                </ul>
            </section>

            {/* SYSTEM IMPACT */}
            <section className="bg-white border border-slate-200 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    System-Wide Impact (Important)
                </h3>

                <p className="text-slate-600 mb-4">
                    Recording a purchase payment triggers automatic updates across multiple
                    modules to keep data consistent.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-2">
                    <li>
                        <strong>Purchases Module:</strong>
                        <ul className="list-disc pl-5 mt-1 text-sm">
                            <li>Received amount increases</li>
                            <li>Remaining balance decreases</li>
                            <li>Status updates automatically (Due / Paid)</li>
                        </ul>
                    </li>

                    <li>
                        <strong>Suppliers Module:</strong>
                        <ul className="list-disc pl-5 mt-1 text-sm">
                            <li>Supplier balance reduces immediately</li>
                            <li>Reflects real-time payable position</li>
                        </ul>
                    </li>
                </ul>
            </section>

            {/* EDIT & DELETE */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Editing & Deleting Payments
                </h3>

                <p className="text-slate-600 mb-4">
                    Payment vouchers can be edited or deleted if entered incorrectly.
                </p>

                <ul className="list-disc pl-5 text-slate-600 space-y-1">
                    <li>Edit opens the same form with auto-filled values</li>
                    <li>Deleting a payment reverses its financial impact</li>
                    <li>Supplier and purchase balances are recalculated automatically</li>
                </ul>
            </section>

            {/* WHY IMPORTANT */}
            <section className="bg-slate-100 rounded-xl p-8">
                <h3 className="font-semibold mb-2">
                    Why Purchase Payments Matter
                </h3>

                <p className="text-slate-600 max-w-3xl">
                    Accurate purchase payment tracking ensures supplier trust, prevents
                    overpayments or missed dues, and provides a transparent financial trail
                    for audits and reporting.
                </p>
            </section>

        </section>
    );
}
